export default __webpack_public_path__ + "static/media/loading3.149a7823.gif";